import { render, staticRenderFns } from "./HistoricoAfastamentos.vue?vue&type=template&id=72afc87c&"
import script from "./HistoricoAfastamentos.vue?vue&type=script&lang=js&"
export * from "./HistoricoAfastamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports